<template>
  <v-container v-if="law">
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>

    <div class="form-npa edit law-edit" v-if="fields">
      <div class="position">
        <div class="bg-white p-20">
          <form action="">
            <div class="form-head">
              <Widget position="menu_profile"/>
            </div>
            <ConfirmationDialog
              v-show="confirmationDialogShow"
              @click="confiramtionDialogClick"
              :title="$t('Вы хотите открыть закон для изменений?')"
            />
            <div class="form-body">
              <div class="top_buttons">
                <div class="status">
                  <span class="draft">
                    {{ $t('Статус') }}: {{ law.statusName }}
                  </span>
                </div>
                <div
                  class="switch"
                  v-if="disabledStatus && editable"
                >
                  <SwitchButton
                    :title="$t('Требуется принятие подзаконных актов')"
                    :switched="law.lawEnforcement"
                    @change="changeSwitch"
                  />
                </div>
                <div v-if="!editable && law.lawEnforcement" class="switch">
                  Требуется принятие подзаконных актов
                </div>
              </div>
              <div class="form-npa-basic">
                <div class="view-npa-body">
                  <div class="form-group">
                    <table class="table">
                      <tbody>
                      <tr>
                        <td>{{ $t("Наименование на государственном языке") }}</td>
                        <td>
                          <template v-if="!fields.nameKg.showEdit">
                            {{ law.nameKg }}
                          </template>
                          <template v-else-if="editable">
                            <InlineEdit
                              :params="fields.nameKg"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.nameKg.showEdit && editable"
                            @click="changeEditShow('nameKg')"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Наименование на официальном языке") }}</td>
                        <td>
                          <template v-if="!fields.name.showEdit">
                            {{ law.name }}
                          </template>
                          <template v-else>
                            <InlineEdit
                              :params="fields.name"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.name.showEdit && editable"
                            @click="changeEditShow('name')"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Номер") }}</td>
                        <td>
                          <template v-if="!fields.number.showEdit">
                            {{ law.number }}
                          </template>
                          <template v-else-if="editable">
                            <InlineEdit
                              :params="fields.number"
                              @update-field="update_field($event)"
                            />
                          </template>
                          <a
                            v-if="!fields.number.showEdit && editable"
                            @click="changeEditShow('number')"
                            class="edit-btn"
                          >
                            <span class="pro-icon-pencil"></span>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Дата принятия") }}</td>
                        <td>
                          <template>
                            <v-menu
                              ref="menu"
                              v-model="fields.adoptionDate.menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <a
                                  v-on="on"
                                  class="law_date"
                                >
                                  <span v-if="law.adoption_date">
                                    {{
                                    new Date(law.adoption_date)
                                    | dateFormat('DD.MM.YYYY')
                                    }}
                                  </span>
                                </a>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-if="fields && editable"
                                v-model="fields.adoptionDate.value"
                                no-title
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                @change="updateAdoptionDate"
                              />
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Дата вступления") }}</td>
                        <td>
                          <template>
                            <v-menu
                              ref="menu2"
                              v-model="fields.effectiveDate.menu2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              min-width="290px"
                            >

                              <template v-slot:activator="{ on }">
                                <a
                                  class="law_date"
                                  v-on="on"
                                >
                                  <span v-if="law.effective_date">
                                    {{
                                    new Date(law.effective_date)
                                    | dateFormat('DD.MM.YYYY')
                                    }}
                                  </span>
                                </a>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-if="fields && editable"
                                v-model="fields.effectiveDate.value"
                                no-title
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                @change="updateEffectiveDate"
                              />
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                       <!------->
                       <tr v-if="isEnforecement">
                        <td>{{ $t("Статус в базе данных") }}</td>
                          <td>
                            <template v-if="!fields.status.showEdit">
                              {{ law.statusName }}
                              <span
                                class="change-status"
                                v-if="!disabledStatus && user.roleAdmin == true"
                                @click="changeStatus"
                              >
                                {{ $t('Открыть для операции') }}
                              </span>
                            </template>

                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.status"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.status.showEdit && editable"
                              @click="changeEditShow('status')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>

                      <tr>
                        <td>{{ $t("Вид закона") }}</td>
                          <td>
                            <template v-if="!fields.kindOfLaw.showEdit">
                              {{ fields.kindOfLaw.fields[0].value }}
                            </template>
                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.kindOfLaw"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.kindOfLaw.showEdit && editable"
                              @click="changeEditShow('kindOfLaw')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>
                      <!------->
                      <tr>
                        <td>{{ $t("Тип закона") }}</td>
                          <td>
                            <template v-if="!fields.lawType.showEdit">
                              {{ fields.lawType.fields[0].value }}
                            </template>
                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.lawType"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.lawType.showEdit && editable"
                              @click="changeEditShow('lawType')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>
                       <!------->
                       <tr>
                        <td>{{ $t("Исполнение законов") }}</td>
                          <td>
                            <template v-if="!fields.executionOfLaw.showEdit">
                              {{ fields.executionOfLaw.fields[0].value }}
                            </template>
                            <template v-else-if="editable">
                              <InlineEdit
                                :params="fields.executionOfLaw"
                                @update-field="update_field($event)"
                              />
                            </template>
                            <a
                              v-if="!fields.executionOfLaw.showEdit && editable"
                              @click="changeEditShow('executionOfLaw')"
                              class="edit-btn"
                            >
                              <span class="pro-icon-pencil"></span>
                            </a>
                          </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Статус закона") }}</td>
                        <td>
                          <div class="link-npa-main" v-if="law.zbdStatus">
                            {{ law.zbdStatus.transName }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("Ссылка на закон") }}</td>
                        <td>
                          <div class="link-cbd" v-if="law.zbdStatus">
                            <p>
                              <a target="_blank" :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + law.zbdCode + '/10?cl=ky-kg'">
                                {{ $t("На гос.языке") }}
                              </a>
                            </p>
                            <p>
                              <a target="_blank" :href="'http://cbd.minjust.gov.kg/act/view/ru-ru/' + law.zbdCode + '/10?cl=ky-kg'">
                                {{ $t("На оф.языке") }}
                              </a>
                            </p>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <DocumentList
                      v-if="law"
                      :documents="law.lawDocuments"
                      @remove="removeLawDocument"
                    />

                    <FileInput
                      v-if="law.lawEnforcement && (this.user.roleAdmin || this.user.roleOperator) &&  this.editable"
                      v-model="files"
                      @save="saveDocument"
                    />
                  </div>
                </div>
                <!------>

                <div
                  class="form-group form-action"
                  v-if="disabledStatus"
                >
                  <template v-for="actionPermission in actionPermissions">
                    <v-btn
                      :key="actionPermission.id"
                      @click="action(actionPermission)"
                      :class="actionPermission.class"
                      rounded
                    >
                      {{ actionPermission.name }}
                    </v-btn>
                  </template>
                </div>
                <!------>
                <div
                  class="create_norm"
                >
                  <div>
                    <div class="create_norm-title">
                      {{ $t('Исполнение законов') }}
                    </div>
                    <div v-if="permissionToAct && (user.roleAdmin || user.roleOperator)"
                      class="create_norm-button"
                      @click="sendCreateNorm"
                    >
                      {{ $t('Добавить норму') }}
                    </div>
                  </div>

                  <div
                    v-if="law.statusId == 5 && law.lawEnforcement && norms.length"
                    class="open_process-status"
                    @click="openProcessStatus"
                  >
                    Открыть для исполнителей
                  </div>
                </div>
                <!---norm---->
                <div>

                  <LawNormTable
                    :norms="norms"
                    :developers="refDevelopers"
                    @remove="removeNorm"
                    :permission-to-act="permissionToAct"
                  />
                </div>
                <!------>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import LAW from '@/model/law'
  import Widget from '@/components/app/Widget'
  import InlineEdit from '@/components/law/InlineEdit'
  import LawNormTable from '@/components/law/LawNormTable'
  import {mapMutations} from 'vuex'
  import moment from 'moment'
  import User from '@/model/user'
  import mixin from '@/plugins/mixin/mixin'
  import {Trans} from "@/plugins/Translation"
  import SwitchButton from '@/components/widget/SwitchButton.vue'
  import ConfirmationDialog from '@/components/widget/ConfirmationDialog.vue'
  import FileInput from '@/components/widget/FileInput.vue'
  import DocumentList from '@/components/widget/DocumentList.vue'

  export default {
    mixins: [mixin],
    props: {
      viewName: {
        type: String,
        default: ''
      }
    },
    components: {
      Widget,
      InlineEdit,
      LawNormTable,
      SwitchButton,
      ConfirmationDialog,
      FileInput,
      DocumentList
    },
    data() {
      return {
        confirmationDialogShow: false,
        byLawsRequired: false,
        editDisableStatuses: [4],
        law: null,
        norms: [],
        lawData: {},
        breadcrumbs: [],
        fields1: null,
        editable: false,
        actionPermissions: null,
        developers: [],
        refDevelopers: [],
        files: [],
      }
    },
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      $route: 'fetchData'
    },
    computed: {
      showFileInput () {
        let ids = [1,3]
        return ids.includes(this.user.id) && this.editable
      },

      user() {
        return this.$store.state.getNpaData.currentUser
      },
      permissionToAct() {
        if (this.law.statusId == null) {
          return
        }

        return this.disabledStatus && this.law.lawEnforcement
      },

      disabledStatus () {
        return !this.editDisableStatuses.includes(this.law.statusId)
      },

      isEnforecement() {
        return this.viewName != 'viewName'
      },
      currentLocaleUrl () {
        return Trans.currentLocaleUrl
      },
      fields () {
        return {
          name: {
            name: 'name',
            showEdit: false,
            fields: [
              {
                name: 'name',
                label: this.$i18n.t('Наименование на официальном языке'),
                value: this.law?.name,
                type: 'varchar'
              }
            ]
          },
          nameKg: {
            name: 'nameKg',
            showEdit: false,
            fields: [
              {
                name: 'nameKg',
                label: this.$i18n.t('Наименование на государственном языке'),
                value: this.law?.nameKg,
                type: 'varchar'
              }
            ]
          },
          number: {
            name: 'number',
            showEdit: false,
            fields: [
              {
                name: 'number',
                label: this.$i18n.t('Номер'),
                value: this.law?.number,
                type: 'varchar'
              }
            ]
          },
          kindOfLaw: {
            name: 'kindOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'kindOfLaw',
                label: this.$i18n.t('Вид закона'),
                value: this.law?.kindOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refKindOfLaw
              }
            ]
          },
          lawType: {
            name: 'lawType',
            showEdit: false,
            fields: [
              {
                name: 'lawType',
                label: this.$i18n.t('Тип закона'),
                value: this.law.lawType?.transName,
                type: 'references',
                referencesData: this.lawData.refLawType
              }
            ]
          },
          status: {
            name: 'status',
            showEdit: false,
            fields: [
              {
                name: 'status',
                label: this.$i18n.t('Статус в базе данных'),
                value: this.law?.statusName,
                type: 'references',
                referencesData: this.lawData.refLawStatus
              }
            ]
          },
          executionOfLaw: {
            name: 'executionOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'executionOfLaw',
                label: this.$i18n.t('Исполнение законов'),
                value: this.law.executionOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refExecutionOfLaw
              }
            ]
          },
          adoptionDate: {
            menu: false,
            value: moment(this.law.adoptionDate).format(
              'YYYY-MM-DD'
            )
          },
          effectiveDate: {
            menu: false,
            value: moment(this.law.effectiveDate).format(
              'YYYY-MM-DD'
            )
          }
        }
      }
    },
    mounted() {
      // загружаем данные, когда представление создано
      // и данные реактивно отслеживаются
      this.fetchData()
      this.scrollToTop()
    },
    methods: {
      ...mapMutations(['setLoading']),
      openProcessStatus () {
        this.setLoading(true)
        LAW.updateLaw({ status: 2 }, this.$route.params.id).then((response) => {
          this.fetchData()
        })
      },

      removeLawDocument (documentId) {
        LAW.removeLawDocument(this.law.id, documentId).then(() =>{
          LAW.getLaw(this.$route.params.id).then((response) => {
            this.law = response.data.law
          })
        })
      },

      saveDocument (form) {
        let fd = new FormData()

        fd.append(`law_document_type[uploadedFile]`, form.file)
        fd.append(`law_document_type[description]`, form.description)
        this.setLoading(true)
        LAW.addLawDocument(this.law.id, fd).then(() => {
          LAW.getLaw(this.$route.params.id).then((response) => {
            this.law = response.data.law
            this.setLoading(false)
          }).catch(() => {
            this.setLoading(false)
          }).catch(() => {
            this.setLoading(false)
          })
        })
      },


      confiramtionDialogClick (type) {
        this.confirmationDialogShow = !this.confirmationDialogShow

        if (type) {
          LAW.updateLaw({ status: 3 }, this.$route.params.id).then((response) => {
            this.update_field({
              status: true,
              fieldName: 'status',
              law: response.data
            })

            this.$nextTick(() => { this.$router.go(0)})
          }).catch(() => {})
        }
      },

      changeStatus () {
        this.confirmationDialogShow = !this.confirmationDialogShow
      },

      changeSwitch () {
        if (this.norms.length > 0 && this.law.lawEnforcement  == true) {
          alert('Сначала удалите все нормы')
          return false
        }

        this.setLoading(true)
        LAW.updateLaw({ lawEnforcement: !this.law.lawEnforcement }, this.law.id).then(() =>{
          this.law.lawEnforcement = !this.law.lawEnforcement
          this.setLoading(false)
        })
      },

      changeEditShow (value) {
        this.fields[value].showEdit = true
        this.$forceUpdate()
      },

      removeNorm (id) {
        console.log(id)
        this.norms = this.norms.filter(item => item.id != id)
      },

      sendCreateNorm() {
        this.$router.push({
          name: 'create-norm',
          params: {
            id: this.law.id
          }
        })
      },
      // подгрузка данных
      fetchData() {
        this.setLoading(true)
        LAW.getLaw(this.$route.params.id).then((response) => {
          this.law = response.data.law
          this.norms = response.data.norms
          this.developers = response.data.developers
          this.refDevelopers = response.data.refDevelopers
          this.setLoading(false)
          this.fetchLawData()
          this.generateBreadcrumbs(this.law.transName)
          this.getActionPermissions(this.law.statusId)
        }).catch((error) => {
          if(error.response.status != null) {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          }
          this.setLoading(false)
        })
      },

      fetchLawData () {
        LAW.getLawData()
          .then((response) => {
            this.lawData = response.data

            this.initFields()
            this.setLoading(false)
          })
          .catch((error) => {

          })
      },
      // генерация хлебных крошек
      generateBreadcrumbs(name) {
        this.breadcrumbs = [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: this.$i18n.t('Исполнение законов'), disabled: false, href: Trans.currentLocaleUrl + '/law'},
          {text: name, disabled: true}
        ]
      },
      //
      initFields() {
        this.lawData.refExecutionOfLaw.push({
          id: null,
          transName: ''
        })
        this.fields = {
          name: {
            name: 'name',
            showEdit: false,
            fields: [
              {
                name: 'name',
                label: this.$i18n.t('Наименование на официальном языке'),
                value: this.law.name,
                type: 'varchar'
              }
            ]
          },
          nameKg: {
            name: 'nameKg',
            showEdit: false,
            fields: [
              {
                name: 'nameKg',
                label: this.$i18n.t('Наименование на государственном языке'),
                value: this.law.nameKg,
                type: 'varchar'
              }
            ]
          },
          number: {
            name: 'number',
            showEdit: false,
            fields: [
              {
                name: 'number',
                label: this.$i18n.t('Номер'),
                value: this.law.number,
                type: 'varchar'
              }
            ]
          },
          kindOfLaw: {
            name: 'kindOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'kindOfLaw',
                label: this.$i18n.t('Вид закона'),
                value: this.law.kindOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refKindOfLaw
              }
            ]
          },
          lawType: {
            name: 'lawType',
            showEdit: false,
            fields: [
              {
                name: 'lawType',
                label: this.$i18n.t('Тип закона'),
                value: this.law.lawType?.transName,
                type: 'references',
                referencesData: this.lawData.refLawType
              }
            ]
          },
          status: {
            name: 'status',
            showEdit: false,
            fields: [
              {
                name: 'status',
                label: this.$i18n.t('Статус в базе данных'),
                value: this.law.statusName,
                type: 'references',
                referencesData: this.lawData.refLawStatus
              }
            ]
          },
          executionOfLaw: {
            name: 'executionOfLaw',
            showEdit: false,
            fields: [
              {
                name: 'executionOfLaw',
                label: this.$i18n.t('Исполнение законов'),
                value: this.law.executionOfLaw?.transName,
                type: 'references',
                referencesData: this.lawData.refExecutionOfLaw
              }
            ]
          },
          adoptionDate: {
            menu: false,
            value: moment(this.law.adoptionDate).format(
              'YYYY-MM-DD'
            )
          },
          effectiveDate: {
            menu: false,
            value: moment(this.law.effectiveDate).format(
              'YYYY-MM-DD'
            )
          }
        }
      },
      // изменение полей
      update_field(result) {
        if (result.law) {
          LAW.getLaw(result.law.law).then((response) => {
            this.setLoading(true)
            this.law = response.data.law
            this.generateBreadcrumbs(this.law.transName)
            this.setLoading(false)
          })
        }
        this.fields[result.fieldName].showEdit = false
        this.$forceUpdate()
      },
      // изменение даты принятия
      updateAdoptionDate(date) {
        this.law.adoptionDate = date
        this.$refs.menu.save(date)
        LAW.updateLaw({adoptionDate: date}, this.law.id).then((response) => {
          let result = response.data
          LAW.getLaw(result.law).then((response) => {
            this.setLoading(true)
            this.law = response.data.law
            this.initFields()
            this.setLoading(false)
          })
        })
      },
      // изменение Даты вступления в силу
      updateEffectiveDate(date) {
        this.law.effectiveDate = date
        this.$refs.menu2.save(date)
        LAW.updateLaw({effectiveDate: date}, this.law.id).then(
          (response) => {
            let result = response.data
            LAW.getLaw(result.law).then((response) => {
              this.setLoading(true)
              this.law = response.data.law
              this.initFields()
              this.setLoading(false)
            })
          }
        )
      },
      // список действий
      getActionPermissions(statusId) {
        User.getActionPermissionsLaw(statusId).then((response) => {
          this.actionPermissions = response.data
        })
      },
      // действия
      action(actionPermission) {
        if (actionPermission.type == 'law_edit') {
          this.editable = true
          return
        }
        if (actionPermission.type == 'law_cancel') {
          this.editable = false
          return
        }
        if (actionPermission.type == 'law_status') {
            LAW.updateStatus(this.law.id, {stageId: actionPermission.id})
              .then((response) => {
                this.law.statusId = response.data.statusId
                this.law.statusName = response.data.statusName
                this.getActionPermissions(this.law.statusId)
              })
              .catch((error) => {
                console.log(error)
                this.$noty.warning(this.$i18n.t('Ошибка'), {
                  killer: true,
                  timeout: 1000,
                  layout: 'topRight'
                })
              })
          this.editable = false

          return
        }
      },
      // Прокручивание к началу страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .create_norm {
    display: flex;
    align-items: center;

    &-title {
      font-weight: 500;
    }

    &-button {
      margin-left: 10px;
      background-color: #004484;
      padding: 5px 15px;
      color: #fff;
      cursor:pointer;
      margin-right: 100px;
    }
  }

  .law_date {
    text-decoration: none;
    color: #000 !important;
  }

  .link-cbd {
    display: flex;
    flex-direction: column;
  }

  .top_buttons {
    display: flex;

    .switch {
      margin-left: 60px;
    }
  }

  .change-status {
    text-decoration: underline;
    margin-left: 40px;
    cursor: pointer;
  }

  .open_process-status {
    background: #d5a154;
    padding: 5px 30px;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
  }
</style>
